import React from 'react'
import IconBan from 'front-end/src/components/common/icon/IconBan'
import { Trans } from '@lingui/macro'
import { Link } from '../../../../components/common/link/Link'
import { getUrlForReceptionist } from 'front-end/src/pages/auth/AuthHelpers'
import { Box } from 'front-end/src/components'

export const OrganisationNotFoundError = () => {
  return (
    <Box className="Auth__noAccess">
      <IconBan />
      <h2>
        <Trans>There is no organisation on this subdomain.</Trans>
      </h2>
      <Link href={`${getUrlForReceptionist()}/findSubdomain`}>
        <Trans>Find your team</Trans>
      </Link>
    </Box>
  )
}
